// import React, { useEffect, useState } from 'react'
// import ReactCardSlider from 'react-card-slider-component';

// import { firestore } from '../firebase';
// import { 
//     collection,
//     getDocs
// } from "firebase/firestore";

// const Packs = () => {

//     const [paquetes, setPaquetes] = useState([])

//   useEffect(() => {
//     async function fetchData() {
//         const querySnapshot = await getDocs(collection(firestore, "paquetes"));
//         querySnapshot.forEach((doc) => {
//             setPaquetes(((prev) => [...prev, doc.data()]))
//         });
//       }
//       fetchData();
//     }, [])
    
//     return (

//         <ReactCardSlider slides={paquetes} />

//     )
// }

// export default Packs
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { firestore } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

const Packs = () => {
  const [paquetes, setPaquetes] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const querySnapshot = await getDocs(collection(firestore, 'paquetes'));
      const docs = querySnapshot.docs.map((doc) => doc.data());
      setPaquetes(docs);
    }
    fetchData();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
  };

  return (
    <Slider {...settings}>
      {paquetes.map((paquete) => (
        <div key={paquete.id}>

          <h3>{paquete.title}</h3>
          <p>{paquete.description}</p>
          <img src={paquete.image} className="pack-image" alt={paquete.title}></img>
        </div>
      ))}
    </Slider>
  );
};

export default Packs;

